module.exports = __webpack_public_path__ + "static/img/dkwps2.d3f7ead.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2.png
// module id = 664
// module chunks = 0